module.exports = __webpack_public_path__ + "img/activity4.1071cca7.png";